import React from "react";

const ChartWrapper = ({ isLoading, children, height = "450px" }) => {
    return (
        <div className="relative bg-[#2D2D30] rounded-lg" style={{ height }}>
            {isLoading ? (
                <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                </div>
            ) : (
                <div className="absolute inset-0 opacity-100 transition-opacity duration-500">
                    {children}
                </div>
            )}
        </div>
    );
};

export default ChartWrapper;
